export default {
    TYPES: {
        CATEGORY: 'category',
        PRODUCT: 'product',
        PAGE: 'page',
        ELEMENT_PAGE: 'elementPage'
    }
};


// WEBPACK FOOTER //
// ./src/app/components/menuEditor/menuConstants.js